import { render } from "./MinusBox.vue?vue&type=template&id=7b95a737"
import script from "./MinusBox.vue?vue&type=script&lang=js"
export * from "./MinusBox.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/MinusBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b95a737"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b95a737', __exports__)) {
    api.reload('7b95a737', __exports__)
  }
  
  module.hot.accept("./MinusBox.vue?vue&type=template&id=7b95a737", () => {
    api.rerender('7b95a737', render)
  })

}


export default __exports__